import React, { useState, useEffect, useRef } from "react";
import { closeIcon, searchIcon, noRecipe } from "assets/icons/importIcon";
import { Button, Popover } from "@material-ui/core";
import imgRecipe from "assets/images/img_recipe.png";
import { getListRecipes } from "actions/recipe";
import AppHelper from "helpers/AppHelper";
import _, { debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { createContent, getListSection, updateContent } from "actions/brik";
import CircularProgress from '@material-ui/core/CircularProgress';
import { alertActions } from 'actions/alert.actions';
import { logoIcon } from 'assets/icons';
import ThumbnailVideo from 'components/Base/ThumbnailVideo'
import useStyles from "./styles";

const ListRecipes = React.forwardRef((props: any, ref: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { listDataRecipe, loadingGetList, loadingCreateRecipe } = useSelector((state: any) => state.recipe);
  const { brikId, sectionId, subId, lastContentOrder, contentId, isReplace } = props;
  const limit = 12;
  const page = useRef(1);
  const [keyWordName, setKeyWordName] = useState<any>('');
  const [shouldLoadMore, setShouldLoadMore] = useState(false);
  const [idRecipe, setIdRecipe] = useState('');
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    setShouldLoadMore(false);
    if (
      !loadingGetList &&
      shouldLoadMore &&
      page.current < listDataRecipe.total_page
    ) {
      page.current = page.current + 1;
      getDataListRecipes();
    }
  }, [shouldLoadMore]);

  useEffect(() => {
    page.current = 1;
    getDataListRecipes();
  }, [keyWordName]);

  useEffect(() => {
    if (page.current === 1) {
      setData(listDataRecipe?.data);
    } else {
      setData([...data, ...listDataRecipe?.data]);
    }
  }, [listDataRecipe]);

  const onClickCreateRecipe = () => {
    AppHelper.showCreateRecipe({ brikId, sectionId, subId, lastContentOrder });
  };

  const onHandleCloseModal = () => {
    AppHelper.hideGlobalModal()
  };

  const handleSelectRecipe = async (selectedId: any) => {
    if (selectedId) {
      AppHelper.hideGlobalModal();

      if (isReplace) {
        const params = {
          recipe_id: selectedId,
          order: lastContentOrder,
        }
        await dispatch(updateContent(brikId, sectionId, subId, contentId, params));
      } else {
        await dispatch(createContent(brikId, sectionId, subId, {
          order: lastContentOrder + 1,
          type: "recipe",
          recipe_id: selectedId
        }))
      }

      await dispatch(getListSection(brikId));
    } else {
      dispatch(alertActions.error('Please choose a recipe'))
    }
  }

  const hanldeChangeSearch = (e: any) => {
    setKeyWordName(e?.target?.value.trim());
  };

  const getDataListRecipes = () => {
    dispatch(getListRecipes(page.current, limit, keyWordName));
  };

  const onScroll = (e: any) => {
    if (
      (e?.target?.clientHeight + e?.target?.scrollTop) > (e?.target?.scrollHeight - 20)
    ) {
      setShouldLoadMore(true);
    }
  };

  return (
    <>
      <div className={classes.container} id="container">
        <div
          className={classes.headerModal}
          style={{
            boxShadow:
              // listRecipe?.length !== 0
              (!_.isEmpty(data) || keyWordName !== '')
                ? "1px 1px 6px rgba(56, 25, 81, 0.25)"
                : "",
          }}
        >
          <div className={classes.titleModal}>
            <p>Add recipe</p>
            <p>Select the recipes you would like to add.</p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                cursor: "pointer",
                padding: '0 0 15px 15px'
              }}
            >
              <img src={closeIcon} alt="" onClick={onHandleCloseModal} />
            </div>
            {/* {listRecipe?.length !== 0 && */}
            {(!_.isEmpty(data) || keyWordName !== '') &&
              <div className={classes.dFlexRight}>
                <div className={classes.btnAddRecipeHeader} onClick={onClickCreateRecipe}>+ New recipe</div>
                <div className={classes.wrapSearch}>
                  <span>
                    <img src={searchIcon} alt="icon" />{" "}
                  </span>
                  <input
                    type="text"
                    placeholder="Search a recipe"
                    onChange={debounce(hanldeChangeSearch, 500)}
                  />
                </div>
              </div>
            }
          </div>
        </div>
        {/* {data?.length === 0 ? ( */}
        {(loadingGetList && (page.current === 1 || !page.current)) ? (
          <div className={classes.styleLoadingPage}>
            <CircularProgress color='inherit' />
          </div>
        ) :
          _.isEmpty(data) ? (
            <div className={classes.bodyModal}>
              <div className={classes.noRecipe}>
                <img src={noRecipe} alt="no recipe" />
                <p>You don’t have any recipes to choose from.</p>
                {keyWordName === '' &&
                  <div
                    className={classes.btnAddRecipeBody}
                    onClick={onClickCreateRecipe}
                  >
                    <Button variant="contained">Create a Recipe</Button>
                  </div>}
              </div>
            </div>
          ) : (
            <>
              <div className={`${classes.bodyModalList} ${classes.fixedHeightList}`} onScroll={onScroll}>
                <div className={classes.listRecipes} id={'listData'}>
                  {data?.map((item: any, index: any) => {
                    return (
                      <div
                        key={item?.id}
                        className={`${classes.itemRecipe} ${item.id === idRecipe ? 'active' : ''}`}
                        onClick={() => {
                          setIdRecipe(item.id)
                          handleSelectRecipe(item.id)
                        }}
                      >
                        <div className={classes.imgRecipe}>
                          {
                            item?.url ? <ThumbnailVideo videoUrl={item?.url} /> : <img src={item?.image ? item?.image : imgRecipe} />
                          }
                        </div>
                        <div className={classes.contentRecipe}>
                          <p className={classes.titleRecipe}>
                            {item?.name}
                          </p>
                          <p className={classes.descriptionRecipe}>
                            {item?.description}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {loadingGetList && page.current > 1 ? (
                  <div className={classes.viewIconLoadmore}>
                    <div className={classes.logoIconLoadmore}>
                      <img src={logoIcon} alt='' />
                    </div>
                  </div>
                ) : null}
              </div>
              {/* <div className={classes.footerModal}>
              <div onClick={onHandleCloseModal}>Cancel</div>
              <div
                className={classes.btnAddRecipeBody}
                style={{ marginTop: 0 }}
                onClick={handleSelectRecipe}
              >
                <Button variant="contained">Done</Button>
              </div>
            </div> */}
            </>
          )}
      </div>
    </>
  );
});

export default ListRecipes;
